import { z } from 'zod'

import {
  BillingProfileDomainQueryModelSchema,
  TeamDomainQueryModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const GetTeamWithBillingProfileInputSchema =
  TeamDomainQueryModelSchema.pick({
    teamId: true,
  })

export type GetTeamWithBillingProfileInput = ZodInfer<
  typeof GetTeamWithBillingProfileInputSchema
>

const BrandTeamWithBillingProfileSchema = TeamDomainQueryModelSchema.extend({
  organizationType: z.literal('brand'),
  billingProfile: BillingProfileDomainQueryModelSchema,
})

const AgencyTeamWithBillingProfileSchema = TeamDomainQueryModelSchema.extend({
  organizationType: z.literal('agency'),
  billingProfile: BillingProfileDomainQueryModelSchema.optional(),
})

const InternalTeamWithBillingProfileSchema = TeamDomainQueryModelSchema.extend({
  organizationType: z.literal('internal'),
  billingProfile: BillingProfileDomainQueryModelSchema.optional(),
})

export const GetTeamWithBillingProfileOutputSchema = z.discriminatedUnion(
  'organizationType',
  [
    BrandTeamWithBillingProfileSchema,
    AgencyTeamWithBillingProfileSchema,
    InternalTeamWithBillingProfileSchema,
  ]
)
export type GetTeamWithBillingProfileOutput = ZodInfer<
  typeof GetTeamWithBillingProfileOutputSchema
>
